import widgetForm from "@/core/services/forms/widgetForm.js";
import { INIT_FORM } from "@/core/services/store/form.module.js";

export default {
    methods: {
        /**
         * Init widget form with edit mode
         * @param {Object} widget
         * @return {void}
         */
        editWidget(widget) {
            let form = JSON.parse(JSON.stringify(widgetForm));
            form.mode = "edit";
            form.fields = {
                _method: "PUT",
                logo: null,
                backgroundColor: widget.backgroundColor
                    ? widget.backgroundColor
                    : form.fields.backgroundColor,
                status: widget.status ? widget.status : form.fields.status,
                message: widget.message ? widget.message : form.fields.message,
                showReviews: widget.showReviews,
            };
            if (widget.logo) {
                form.helpers.logo = widget.logo;
            }
            this.$store.dispatch(INIT_FORM, form);
        },
    },
};
